import React, { useEffect } from 'react';
import '../styles/horse-race.css';

const ReddyAnnaHorseRacePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="horse-race-betting-page">
      <div className="horse-race-betting-intro">
        <div className="horse-race-betting-intro-content">
          <h1><span>Mahadev Horse Race Betting:</span> Chase the Thrill. Bet the Win.</h1>
          <p>
            Welcome to Mahadev Horse Race Betting — where heart-pounding races meet next-level betting excitement. Whether you're a die-hard racing fan or new to the tracks, we bring the energy of the derby straight to your fingertips.
          </p>
          <div className="horse-race-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="horse-race-betting-intro-image">
          <img src="/horse-race-betting.webp" alt="Horse Race Betting" />
        </div>
      </div>

      <section className="horse-race-betting-features">
        <h2>Why Choose <span>Mahadev Horse Racing?</span></h2>
        <ol>
          <li>
            <strong>Get Your Mahadev Horse Race ID:</strong> Unlock access to top-tier tracks, exciting races, and exclusive betting opportunities with your personalized Mahadev ID.
          </li>
          <li>
            <strong>Easy Setup:</strong> Register in minutes and get started immediately. Log in anytime to place bets, view odds, or track race results.
          </li>
          <li>
            <strong>Bet from Anywhere:</strong> With our mobile app, the racetrack is always in your pocket. Bet live, track real-time updates, and never miss a photo finish!
          </li>
          <li>
            <strong>24/7 Dedicated Support:</strong> Need help? We’re here for you. Reach out on WhatsApp or give us a call — our support team has your back.
          </li>
        </ol>
      </section>

      <section className="horse-race-betting-getting-started">
        <h2>Getting Started is Easy</h2>
        <ol>
          <li>
            <strong>Register Your Account:</strong> Sign up on our site or app to receive your Mahadev Horse Race ID.
          </li>
          <li>
            <strong>Log In:</strong> Access your dashboard and explore the latest races and odds.
          </li>
          <li>
            <strong>Explore the Races:</strong> Browse through local and international racing events. Pick your favorite horses and analyze race details.
          </li>
          <li>
            <strong>Place Your Bets:</strong> Bet confidently with real-time odds, expert insights, and live race coverage.
          </li>
          <li>
            <strong>Reach Out Any Time:</strong> Have questions? Our team is always available on WhatsApp or phone for anything you need.
          </li>
        </ol>
        <div className="horse-race-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="horse-race-betting-join">
        <h2>Join <span>Mahadev Horse Race Betting</span> Today!</h2>
        <p>
          Experience the adrenaline of the racetrack — live betting, unbeatable odds, and a smooth, powerful platform built just for you. Don’t just watch the race. Be part of it. Join Mahadev and ride with the winners!
        </p>
        <div className="horse-race-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>
  );
};

export default ReddyAnnaHorseRacePage;
